import { jsx as _jsx } from "react/jsx-runtime";
import { ChevronRight } from '@awaze/design-system.components.icon';
export const buttonProps = {
    type: 'button',
    isFullWidth: true,
    gap: 1,
    icon: _jsx(ChevronRight, {}),
    iconPosition: 'right',
    justify: 'space-between',
    fullWidth: true,
};
export const activeButtonProps = {
    ...buttonProps,
    colourScheme: 'brand-secondary',
};
export const getFilteredDestinations = (destinations, getBoats, popularLabel) => {
    if (getBoats) {
        return destinations.filter(({ regionName }) => regionName === 'Boats');
    }
    const filteredDestinations = destinations.filter(({ regionName }) => regionName !== 'All of UK' && regionName !== 'Boats');
    return popularLabel
        ? [
            ...filteredDestinations,
            {
                regionName: popularLabel,
                regionValue: popularLabel,
                regionId: 0, // 0: Popular-Destinations Reveal-Trigger
                url: '',
            },
        ]
        : filteredDestinations;
};
export const getPopularDestinations = (destinations) => {
    const popular = destinations.map((region) => {
        if (region.popular) {
            region.popular.title = region.popular.title.replace('Popular in ', '');
            return region.popular;
        }
        return null;
    });
    return popular.filter(Boolean);
};
// Returns array of number of items per column
export const getNumberOfColumns = (maximumItems, totalItems) => {
    const numberOfColumnsStartIndex = [];
    for (let i = maximumItems; i < totalItems + maximumItems; i += maximumItems) {
        numberOfColumnsStartIndex.push(i - maximumItems);
    }
    return numberOfColumnsStartIndex.length ? numberOfColumnsStartIndex : [0];
};
// Remove marging-bottom if part of preceeding split-columns, except for last column element
export const noBottomMargin = (numberOfColumns, index) => numberOfColumns.length !== 1 && index !== numberOfColumns.length - 1;
export const getPopularColumnRange = (locations, startIndex, maximumColumnItems) => locations.filter((location, index) => index >= startIndex && index <= startIndex + maximumColumnItems - 1);
//# sourceMappingURL=destination-shared-utils.js.map